import { gql } from '@apollo/client';

export const CREATE_NOTE_MUTATION = gql`
  mutation CreateNote(
    $note: String!
    $userId: String!
    $routeId: String
    $clientId: String
    $vendorId: String
    $dropoffId: String
    $greaseTrapId: String
  ) {
    createNote(
      note: $note
      userId: $userId
      routeId: $routeId
      clientId: $clientId
      vendorId: $vendorId
      dropoffId: $dropoffId
      greaseTrapId: $greaseTrapId
    ) {
      status
      code
      data
      error
    }
  }
`;
